import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { convertDateStringsToDates } from 'src/util/dateLib';

@Injectable()
export class DateConvertorInterceptor implements HttpInterceptor {
  constructor() {}
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method === 'GET') {
      return next.handle(request).pipe(
        map((res) => {
          if (res instanceof HttpResponse && res.body != null) {
            convertDateStringsToDates(res.body);
          }
          return res;
        }),
      );
    }
    return next.handle(request);
  }
}
